import { CustomEditableTextContent2 } from '../leaf/customEditableText/customEditableTextContent'
import React from 'react'

const SpreadsheetFormatter = ({ value }) => {
  return (<CustomEditableTextContent2 children={value} refCalc={() => {}} style={{ height: null, width: '100%', top: '-9px' }} />)
}

export default SpreadsheetFormatter
